<ng-template #operationFinish></ng-template>

<div class="jumbotron" *ngIf="!finishComponent">
  <div class="centered-text">Operace byla úspěšně provedena. Přejete si provést další hromadnou operaci nad zvoleným seznamem?</div>
  <div class="centered-text mt-10">
    <gmt-button [clickAction]="newOperation">Ano</gmt-button>
    <gmt-button [clickAction]="goToList">Ne</gmt-button>
  </div>
</div>